/**
* Script form.js
* Contient tous les scripts lié aux formulaires
* - Validation
* - gestion des étapes
*/

import '../vendor/steps'; // Gestion des étapes d'un formulaire
import '../node_modules/selectric/public/jquery.selectric'  // list déroulante selectric
import '../node_modules/parsleyjs/dist/parsley'; // System de validation
import './autocomplete-google'; // Gestion de l'autocomplète google
   
/**
 * Objet Completude + gestion de la validation
 */
(function(w) {
    // Définit l'objet Completude

    w.Completude = Object.assign({},w.Completude);
    
    /**
     * Initialise la validation d'un formulaire ( )
    * @param $form 
    */
    w.Completude.SetFormValidation = function($form) {

        var selectricRefresh = function($select) {
            // Si il y a une valeur, on ajoute la classe changed
            if ($select.val()!=="" && $select.val()!==null) {                    
                $select.closest('.select').addClass("changed");
            } else {
               $select.closest('.select').removeClass("changed");
            }                
            // Gestion du disabled                
            if ($select.attr('disabled')=='disabled') {
                $select.closest('.select').next('label.floating-label').css("opacity","0.5");
            } else {
                $select.closest('.select').next('label.floating-label').css("opacity","1");
            }
        }

        //Liste déroulante custom  ( library selectricjs)
        $form.find('.selectric').selectric({
            disableOnMobile: false,
            nativeOnMobile: false,
            onInit: function () {                
                //var $select = $(this);
                selectricRefresh($(this));
            },
            onRefresh: function() {
                selectricRefresh($(this));
            }            
        });
        //Force la validation avec parsley pour les composants selectric 
        $form.find('.selectric').on('selectric-change', function(event, element, selectric) {
            if (typeof(element)!=='undefined') {
            var e = jQuery(element).parsley();            
            selectricRefresh($(element));
            e.validate();        
            }
        });
  
        /** Option par defaut de la library parsley */
        var $parsley = $form.parsley({
            inputs: Parsley.options.inputs,
            excluded: 'input[type=button], input[type=submit], input[type=reset], [disabled] , input.selectric-input',
            errorClass: 'error',
            successClass: 'success',
            trigger: 'change blur',
            errorsContainer: function (field) {
                var $field = $(field.$element)
                if ($field.hasClass('form__controls')) {
                    return $field
                }
                return $field.closest('.form__controls')
            },
            classHandler: function (field) {
                var $field = $(field.$element)
                if ($field.hasClass('form__controls')) {
                    return $field
                }
                return $field.closest('.form__controls')
            },
            errorsWrapper: '<ul class="error-text parsley-errors-list"></ul>'
        })
      
        return $parsley;
    
    }; 

    /**
    * Scroll sur la première erreur si erreur il y a
    */
    window.Parsley.on('form:error', function (formInstance) {
        try {
            var $form = $(formInstance.$element);
            var firstErrorElement = $form.find('.error:first');
            if(!firstErrorElement.is(':visible')){
                firstErrorElement = firstErrorElement.siblings('label:first');
                $('html, body').animate({
                    scrollTop: firstErrorElement.offset().top - $('header').height()
                }, 'slow');
            }      
        }
        catch(e) {
            console.info(e);
        }
    })

    // Validation errors messages for Parsley
    // Load this after Parsley

    Parsley.addMessages('fr', {
        defaultMessage: "Cette valeur semble non valide.",
        type: {
        email:        "Le format de l’email n’est pas valide.",
        url:          "Cette valeur n'est pas une URL valide.",
        number:       "Cette valeur doit être un nombre.",
        integer:      "Cette valeur doit être un entier.",
        digits:       "Cette valeur doit être numérique.",
        alphanum:     "Cette valeur doit être alphanumérique."
        },
        notblank:       "Cette valeur ne peut pas être vide.",
        required:       "Ce champ est requis.",
        pattern:        "Cette valeur semble non valide.",
        min:            "Cette valeur ne doit pas être inférieure à %s.",
        max:            "Cette valeur ne doit pas excéder %s.",
        range:          "Cette valeur doit être comprise entre %s et %s.",
        minlength:      "Cette chaîne est trop courte. Elle doit avoir au minimum %s caractères.",
        maxlength:      "Cette chaîne est trop longue. Elle doit avoir au maximum %s caractères.",
        length:         "Cette valeur doit contenir entre %s et %s caractères.",
        mincheck:       "Vous devez sélectionner au moins %s choix.",
        maxcheck:       "Vous devez sélectionner %s choix maximum.",
        check:          "Vous devez sélectionner entre %s et %s choix.",
        equalto:        "Cette valeur devrait être identique."
    });

    Parsley.setLocale('fr');


    /** Validateur spécifique */
    // N° de telephone Validateur

    Parsley.addValidator('telephone', {
        requirementType: 'string',
        validateString: function (phone) {
            return /^(((\+)33|0)[1-9]((\.|\-|\||\/?)\d{2}){4})?$/g.test(phone)
        },
        messages: {
            en: 'It\'s not a valid french phone number.',
            fr: 'Ce n\'est pas un numéro de téléphone valide.'
        }
    })

    // If check Validator
    Parsley.addValidator('requiredifchecked', {
        requirementType: "string",
        validateString: function (value, requirement) {        
            var checked = $(requirement).prop('checked');
            return (value!='' && checked) || !checked;
        },
        messages: {
            fr: 'Ce champ est obligatoire.'
        }
    })

    // Adresse validateur ()
    Parsley.addValidator('address', {
        requirementType: "string",
        validateString: function(value, form) {
            if(typeof window.autocomplete                  === 'undefined' || window.autocomplete === null)                    return false;
            if(typeof window.autocomplete.localisation     === 'undefined' || window.autocomplete.localisation === null)       return false;
            if(typeof window.autocomplete.localisation.lat === 'undefined' || window.autocomplete.localisation.lat === null)   return false;
            if(typeof window.autocomplete.localisation.lng === 'undefined' || window.autocomplete.localisation.lng === null)   return false;
            return true;                
        },
        messages: {
            fr: 'Ce n\'est pas une adresse valide.'
        }
    })            
                
})(window);


jQuery(function() {
    //  Force la validation avec parsley sur un changement d'un autocomplete
    jQuery("input.google-autocomplete").each(function(index,element) {
        jQuery(element).on("google-autocomplete-changed",function() {
            //console.debug("validation parsley");                    
            var e = jQuery(this).parsley();                    
            e.validate(); 
        });
    });
});